import { type SizePreset } from '@/types';

/** Hard upload ceiling: 1 GB. */
export const MAX_FILE_BYTES = 1024 * 1024 * 1024;

/** MIME types we accept, mapped to their canonical extensions. */
export const ACCEPTED_TYPES: Readonly<Record<string, readonly string[]>> = {
  'video/mp4': ['.mp4', '.m4v'],
  'video/quicktime': ['.mov'],
  'video/webm': ['.webm'],
  'video/x-matroska': ['.mkv'],
  'video/ogg': ['.ogv', '.ogg'],
  'video/x-msvideo': ['.avi'],
};

export const ACCEPTED_EXTENSIONS: readonly string[] = Object.values(ACCEPTED_TYPES).flat();

/** Value for `<input accept>`. */
export const FILE_ACCEPT = [...Object.keys(ACCEPTED_TYPES), ...ACCEPTED_EXTENSIONS].join(',');

export const SIZE_PRESET_OPTIONS: ReadonlyArray<{ value: SizePreset; label: string }> = [
  { value: 'auto', label: 'Auto (recommended)' },
  { value: 'original', label: 'Original size' },
  { value: '480', label: '480 px wide' },
  { value: '360', label: '360 px wide' },
  { value: '240', label: '240 px wide' },
  { value: 'custom', label: 'Custom…' },
];

export const SPEED_OPTIONS: ReadonlyArray<{ value: number; label: string }> = [
  { value: 0.25, label: '0.25×' },
  { value: 0.5, label: '0.5×' },
  { value: 0.75, label: '0.75×' },
  { value: 1, label: '1× (normal)' },
  { value: 1.5, label: '1.5×' },
  { value: 2, label: '2×' },
  { value: 3, label: '3×' },
  { value: 4, label: '4×' },
];

/** GIF delays are in centiseconds, so ~50 fps is the practical ceiling. */
export const MAX_GIF_FPS = 50;
export const MIN_GIF_FPS = 1;

export const MIN_DIMENSION = 16;
export const MAX_DIMENSION = 1920;

/** Shortest allowed trim selection, seconds. */
export const MIN_TRIM_SECONDS = 0.1;

/** Above this many output frames we warn: encodes get slow and files get big. */
export const FRAME_COUNT_WARNING = 1200;
